import SectionCard from '../shared/SectionCard'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'

import FeedbackFiltersBar from './FeedbackFiltersBar'
import FeedbackTable from './FeedbackTable'
import useFeedback from './useFeedback'
import { NotificationsWrapper, Stack } from './styled-components'

const FeedbackPage = () => {
  const { filters, table, exportCsv } = useFeedback()

  return (
    <Stack>
      <SectionCard>
        <FeedbackFiltersBar filters={filters} exportCsv={exportCsv} />

        <NotificationsWrapper>
          <SDNotification type='negative' hidden={!exportCsv.exportError} primaryText={String(exportCsv.exportError || '')} />
        </NotificationsWrapper>
      </SectionCard>

      <FeedbackTable
        rows={table.rows}
        isLoading={table.isLoading}
        error={table.error}
        pagination={table.pagination}
      />
    </Stack>
  )
}

export default FeedbackPage
